import "./SetUpPassword.scss";
import { useEffect } from "react";
import { useAppSelector, useAppDispatch } from "store";
import Header from "components/Header/Header";
import CabinerCopyrightSection from "components/CabinetCopyrightSection/CabinetCopyrightSection";
import SetUpInfo from "./SetUpInfo/SetUpInfo";
import PasswordForm from "./PasswordForm/PasswordForm";
import ErrorPopup from "./ErrorPopUp/ErrorPopup";
import { passwordActions } from "store/reducers/setupPassword";
import CommonPopup from "components/PopUps/CommonPopup/CommonPopup";

const SetUpPassword = () => {
  const {
    isSet,
    isOpenErrorPopup,
    errorHeader,
    errorMessage,
    resultHeader,
    resultMessage,
    isOpenResultPopup,
  } = useAppSelector((state) => state.setPassword);
  const dispatch = useAppDispatch();

  const closeErrorPopup = () => {
    dispatch(passwordActions.setCloseErrorPopup());
  };

  const closeResultPopup = () => {
    dispatch(passwordActions.setCloseResultPopup());
  };

  useEffect(() => {
    if (isSet) {
      window.location.href = "/?form=sign";
    }
  }, [isSet]);
  return (
    <div className="setup-password">
      {isOpenResultPopup && (
        <CommonPopup
          onClick={closeResultPopup}
          header={resultHeader || ""}
          desc={resultMessage}
        />
      )}

      {isOpenErrorPopup && (
        <ErrorPopup
          header={errorHeader}
          errorText={errorMessage}
          onClose={closeErrorPopup}
        />
      )}
      <Header isSetup={true} logout={() => {}} />
      <div className="setup-password-container">
        <SetUpInfo />
        <PasswordForm />
      </div>
      <CabinerCopyrightSection />
    </div>
  );
};

export default SetUpPassword;
